import { Record } from "immutable";

import { ThousandSeparatorFormatNames } from "../../../../constants/dateFormats";
import { DateOrderIdentifiers } from "../../../../constants/dateOrders";
import GlobalFontSizes from "../../../../constants/globalFontSizes";
import { SkinIdentifiers } from "../../../../constants/skinOptions";
import createFromJS from "../../../createFromJS";

export const PreferencesRecord = Record({
  dateOrder: DateOrderIdentifiers.MonthDayYear,
  thousandsSeparator: ThousandSeparatorFormatNames.Comma,
  skin: SkinIdentifiers.AeonBlue,
  autoBackupEnabled: false,
  autoBackupLocation: null,
  autoCheckUpdates: true,
  autoDownloadUpdates: true,
  autoCloseScrivener: false,
  autoCloseScrivenerRequested: false,
  globalFontSize: GlobalFontSizes.Medium
});

createFromJS.registerCallback("PreferencesRecord", createFromJS.createPrimitiveCallback(PreferencesRecord));
